import React from "react";

const SwitchInput = ({
  label,
  description = "",
  isBordered = false,
  checked,
  disabled,
  change,
  className,
  input,
  font,
}) => {
  const handelChange = (e) => {
    change && change(e.target.checked);
  };

  return (
    <div className={className}>
      <label
        className={`group relative inline-flex cursor-pointer transition-all duration-200 ${
          isBordered
            ? `w-full items-center gap-3 overflow-hidden rounded-2xl border p-3 ${
                checked
                  ? "border-emerald-200 bg-gradient-to-br from-emerald-50/70 via-white to-emerald-50/40 shadow-sm shadow-emerald-700/5 dark:border-emerald-800/50 dark:from-emerald-950/40 dark:via-gray-800 dark:to-emerald-950/20"
                  : "border-gray-200 bg-white hover:border-gray-300 dark:border-gray-600 dark:bg-gray-700"
              }`
            : "w-fit items-center"
        } ${disabled ? "cursor-not-allowed opacity-60" : ""}`}
      >
        {/* Decorative orb when checked + bordered */}
        {isBordered && checked && (
          <span
            aria-hidden
            className="pointer-events-none absolute -end-8 -top-8 h-20 w-20 rounded-full bg-gradient-to-br from-emerald-200/40 to-transparent blur-2xl dark:from-emerald-700/30"
          />
        )}

        <input
          type="checkbox"
          className="peer sr-only"
          {...input}
          disabled={disabled}
          onChange={handelChange}
          checked={checked}
        />

        {/* Track */}
        <span
          className={`peer relative inline-block h-[22px] w-11 shrink-0 rounded-full transition-colors duration-300 ${
            checked
              ? "bg-gradient-to-r from-emerald-400 to-emerald-600 shadow-inner shadow-emerald-700/20 dark:from-emerald-500 dark:to-emerald-700"
              : "bg-gray-200 dark:bg-gray-600"
          } peer-focus-visible:ring-2 peer-focus-visible:ring-purple-300 peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-white dark:peer-focus-visible:ring-purple-700 dark:peer-focus-visible:ring-offset-gray-900`}
        >
          {/* Knob */}
          <span
            className={`absolute top-1/2 inline-block h-[18px] w-[18px] -translate-y-1/2 rounded-full bg-white dark:bg-gray-200 shadow-md shadow-gray-900/15 ring-1 transition-all duration-300 ease-out ${
              checked
                ? "end-[3px] ring-emerald-200 dark:ring-emerald-800"
                : "end-[23px] ring-gray-200 dark:ring-gray-600"
            }`}
          />
        </span>

        <span
          className={`relative ms-2 flex-1 text-start ${font ? font : "text-[15px]"} ${
            checked && isBordered
              ? "text-emerald-800 dark:text-emerald-300"
              : "text-gray-700 dark:text-gray-300"
          }`}
        >
          <span
            className={`${checked && isBordered ? "font-semibold tracking-tight" : "font-medium"}`}
          >
            {label}
          </span>
          {description && (
            <p
              className={`mt-0.5 text-xs ${
                checked && isBordered
                  ? "text-emerald-600/80 dark:text-emerald-400/80"
                  : "text-gray-400 dark:text-gray-500"
              }`}
            >
              {description}
            </p>
          )}
        </span>

        {/* Active indicator pill on bordered+checked */}
        {isBordered && checked && (
          <span className="relative inline-flex items-center gap-1 rounded-full bg-emerald-500/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-emerald-700 ring-1 ring-emerald-200 dark:bg-emerald-500/20 dark:text-emerald-300 dark:ring-emerald-800/50">
            <span className="h-1 w-1 animate-pulse rounded-full bg-emerald-500" />
            مفعل
          </span>
        )}
      </label>
    </div>
  );
};

export default React.memo(SwitchInput);
